import { fileIsImage } from 'utils/typeguards'

export type ImageMetadata = {
  height: number
  width: number
  byteSize: number
}

/**
 * Function that accepts File and returns metadata for image type files.
 * Returns error when file's mimetype is not *image/**
 * @param file - Image file which metadata are to be extracted
 * @returns Metadata object of type  {@link ImageMetadata}
 */
export function getImageMetadata(file: File) {
  return new Promise<ImageMetadata>((resolve, reject) => {

    if (!fileIsImage(file)) return reject('Unsupported file type')

    try {
      const reader = new FileReader()

      reader.onload = () => {
        const img = new Image()

        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height,
            byteSize: file.size,
          })
        }

        // A file the browser cannot decode (camera RAW, a corrupt image) fires no load, so without this the promise never settles.
        img.onerror = () => reject('Couldn\'t decode the image')

        if (typeof reader.result === 'string') img.src = reader.result
        else reject('Couldn\'t read uploaded file')
      }
      reader.onerror = () => reject('Couldn\'t read uploaded file')

      reader.readAsDataURL(file)
    } catch (e) {
      reject('Couldn\'t read uploaded file')
    }

  })
}
